<template>
    <div :class="active ? 'block' : 'hidden'">
        <div class="fixed z-50 pin overflow-hidden bg-modal" @click.prevent="close"></div>
        <button @click.prevent="close" class="z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2">
            <span class="icon"><i class="mdi mdi-close"></i></span>
        </button>
        <div class="fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4">
            <div class="bg-white rounded shadow">
                <div class="px-6 py-3"><span class="uppercase tracking-wide text-grey-dark font-semibold">{{ $t('Choose_your_language') }}</span></div>
                <label v-for="language in languages" :key="language.id" class="block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker">
                    <input type="radio" v-model="selectedLanguage" class="mr-2" v-bind:value="language" @change="submit"> <span v-text="language.name"></span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import helpers from '@/mixins/helpers'

import patientRepository from '@/data/PatientRepository'

export default {
    name: 'language-switcher-modal',

    props: ['active'],

    mixins: [helpers],

    data: () => ({
        selectedLanguage: null
    }),

    mounted () {
        let language = localStorage.getItem('language') || (this.patient ? this.patient.language : this.frontLanguage) || 'en'
        this.selectedLanguage = _.find(this.languages, {shortCode: language})
    },

    methods: {
        submit () {
            if (this.patient) {
                patientRepository.update({
                    id: this.patient.id,
                    language: this.selectedLanguage.shortCode
                }, (patient) => {
                    patientRepository.find(this.patient.id, (patient) => {
                        this.$store.dispatch('setPatient', patient)
                        this.$store.dispatch('setFrontLanguage', this.selectedLanguage.shortCode)
                        this.$store.dispatch('setLocale', this.selectedLanguage.code)
                        this.$emit('close')
                    }, (error) => {
                        console.log(error);
                    })
                    // this.$store.dispatch('setPatient', Object.assign(this.patient, {language: this.selectedLanguage.shortCode}))
                }, () => {})
            } else {
                this.$store.dispatch('setFrontLanguage', this.selectedLanguage.shortCode)
                this.$store.dispatch('setLocale', this.selectedLanguage.code)
                this.$emit('close')
            }
        },

        close () {
            this.$emit('close')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Patient/LanguageSwitcherModal.vue